import { checkboxAnatomy } from "@chakra-ui/anatomy";
import { createMultiStyleConfigHelpers } from "@chakra-ui/react";
import { defineStyle } from "@chakra-ui/styled-system";

const { definePartsStyle, defineMultiStyleConfig } = createMultiStyleConfigHelpers(
  checkboxAnatomy.keys
);

const baseStyleContainer = defineStyle({
  rounded: "base",
});

const baseStyleIcon = defineStyle({
  boxSize: 4,
});

const baseStyleControl = defineStyle({
  rounded: "base",
  borderWidth: "base",
  borderColor: "brand.sky",

  _focusVisible: {
    boxShadow: "0 !important",
  },
  _checked: {
    borderColor: "brand.analytic !important",
    bg: "brand.analytic !important",
  },
  _indeterminate: {
    borderColor: "brand.analytic !important",
    bg: "brand.analytic !important",
  },
});

const baseStyle = definePartsStyle({
  container: baseStyleContainer,
  icon: baseStyleIcon,
  control: baseStyleControl,
});

export const checkboxTheme = defineMultiStyleConfig({ baseStyle });
